<template>
    <div class="d-inline ml-1">
        <v-chip v-if="activeTaskStatus == 'completed'" class="spray-complete-card" :size="chipSize"><v-icon icon="mdi-progress-check"></v-icon> SPRAYING COMPLETED</v-chip>
        <v-chip v-if="activeTaskStatus == 'packed'" class="packing-complete-card" :size="chipSize"><v-icon icon="mdi-package-variant-closed-check"></v-icon> PACKING COMPLETED</v-chip>
        <v-chip v-if="activeTaskStatus == 'spraying'" class="spraying-card" :size="chipSize"><v-icon icon="mdi-spray"></v-icon> SPRAYING</v-chip>
    </div>
</template>
<style scoped lang="scss">
    @import '../../styles/smart.scss';
</style>
<script>
    function initialState() {
        return {
            loading: false
        };
    }
    import { mapActions } from "vuex";
    export default {
        name: "ActiveTaskStatus",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            job: Object,
            size: String
        },
        methods: {
            ...mapActions([
            ]),
        },
        computed: {
            chipSize() {
                return !this.size ? 'x-small' : this.size;
            },
            activeTaskStatus() {
                if (this.job) {
                    let status = this.job.jobStatus ? this.job.jobStatus : this.job.activeTask.status;
                    if (status <= this.$constants.jobs.JOBSTAT_INVOICE && (this.job.activeTask.status == this.$constants.jobs.JOBSTAT_LINE1 || this.job.activeTask.status == this.$constants.jobs.JOBSTAT_LINE2)) {
                        if (this.job.activeTask.packed) {
                            return 'packed'
                        } else if (this.job.activeTask.completed) {
                            return 'completed'
                        } else if (this.job.activeTask.running) {
                            return 'spraying'
                        }
                    }
                }
                return null;
            }
        }
    };
</script>